/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Avatar_BillingInputs */

const en_dashboard_avatar_billing = /** @type {(inputs: Dashboard_Avatar_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Billing`)
};

const es_dashboard_avatar_billing = /** @type {(inputs: Dashboard_Avatar_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facturacion`)
};

/**
* | output |
* | --- |
* | "Billing" |
*
* @param {Dashboard_Avatar_BillingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dashboard_avatar_billing = /** @type {((inputs?: Dashboard_Avatar_BillingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Avatar_BillingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_avatar_billing(inputs)
	return es_dashboard_avatar_billing(inputs)
});